import React from 'react';
import styled from 'styled-components';
import CardHeader from './header';
import { media, spacing } from '../../theme';
import colors from '../../theme/variables/colors';

const CardContainer = styled.div<{className?: string}>`
    border: ${props => (props.className?.includes('notBordered') ? '0px' : '1px')} solid ${colors.palette.greyscale40};
    padding: ${props => (props.className?.includes('notBordered') ? '0' : `${spacing.spacing3} ${spacing.spacing2}`)};
    margin-bottom: ${spacing.spacing5};
    background: transparent;
    border-radius: 10px;
    box-shadow: ${props => (props.className?.includes('notBordered') ? 'none' : `${spacing.spacing0} 2px ${spacing.spacing1} 0.1px rgba(176, 176, 176, 0.25)`)};

    @media (${media.small}) {
        padding: ${props => (props.className?.includes('notBordered') ? '0' : `${spacing.spacing4} ${spacing.spacing5}`)};
    }
`;

interface CardProps {
    id?: string;
    title?: string | null;
    header?: React.ReactNode;
    link?: React.ReactNode;
    content: React.ReactNode;
    footerContent?: React.ReactNode;
    className?: string;
}

export default function Card(props: CardProps) {
    const { id, title, header, link, content, footerContent, className } = props;
    return (
        <>
            <CardContainer id={id ? id : 'cardContainer'} className={className} tabIndex={-1}>
                {React.isValidElement(header) ? header : title && <CardHeader id={`${id}-header`} title={title} link={link} />}
                {React.isValidElement(content) && content}
                {React.isValidElement(footerContent) && footerContent}
            </CardContainer>
        </>
    );
}
